<template>
  <div id="pk-list" class="relativeItem">
    <!--关闭页面的按钮-->
    <a class="close_img imgBlock" @click="close_web">
      <img src="../../assets/qixi/qixi(41).png" class="imgBlock noevents-img" />
    </a>

    <!-- 查看榜单的按钮 -->
    <a class="gz-btn imgBlock" @click="clickRolue(false)" v-show="show_gz">
      <img src="../../assets/pk4/btnfan.png" class="imgBlock noevents-img" />
    </a>
    <!--查看规则的按钮-->
    <a class="gz-btn imgBlock" @click="clickRolue(true)" v-show="!show_gz">
      <img src="../../assets/pk4/rbtn01.png" class="imgBlock noevents-img" />
    </a>

    <!--顶部动画-->
    <div class="head_box relativeItem">
      <img class="imgBlock noevents-img" src="../../assets/pk4/tuobg.png" />
      <div id="anim" class="absoluteItem centerX" v-show="!show_gif"></div>
      <div id="anim2" class="absoluteItem centerX" v-show="show_gif"></div>
    </div>

    <!--榜单-->
    <div id="list_id" class="list_div relativeItem" v-show="!show_gz">
      <!-- 按钮区域 -->
      <div class="type-an2 flex-box relativeItem">
        <img
          class="imgBlock noevents-img chi_img"
          src="../../assets/pk4/cleft.png"
        />
        <div class="side_con side1 flex-box" @click="se_type_an = 0">
          <img
            src="../../assets/pk4/btn1.png"
            class="imgBlock noevents-img"
            v-show="se_type_an != 0"
          />
          <img
            src="../../assets/pk4/btn1a.png"
            class="imgBlock noevents-img"
            v-show="se_type_an == 0"
          />
        </div>

        <div class="side_con flex-box" @click="se_type_an = 1">
          <img
            v-show="se_type_an != 1"
            src="../../assets/pk4/btn2.png"
            class="imgBlock noevents-img"
          />
          <img
            src="../../assets/pk4/btn2a.png"
            class="imgBlock noevents-img"
            v-show="se_type_an == 1"
          />
        </div>

        <div class="side_con flex-box" @click="se_type_an = 2">
          <img
            v-show="se_type_an != 2"
            src="../../assets/pk4/btn3.png"
            class="imgBlock noevents-img"
          />
          <img
            src="../../assets/pk4/btn3a.png"
            class="imgBlock noevents-img"
            v-show="se_type_an == 2"
          />
        </div>

        <div class="side_con side4 flex-box" @click="se_type_an = 3">
          <img
            v-show="se_type_an != 3"
            src="../../assets/pk4/btn4.png"
            class="imgBlock noevents-img"
          />
          <img
            src="../../assets/pk4/btn4a.png"
            class="imgBlock noevents-img"
            v-show="se_type_an == 3"
          />
        </div>
        <img
          class="imgBlock noevents-img chi_img"
          src="../../assets/pk4/cright.png"
        />
      </div>
      <div class="bgline"></div>

      <div class="rank_main">
        <!-- 前三名 -->
        <div class="san_main">
          <div class="three_box relativeItem">
            <img
              class="imgBlock noevents-img"
              src="../../assets/pk4/bgt01.png"
            />
            <div
              class="absoluteItem san_con centerX"
              v-if="rankList.length > 2"
            >
              <div class="first_con flex-box">
                <img
                  class="m1_img imgBlock noevents-img"
                  src="../../assets/pk4/m1.png"
                />
                <div class="kg_first relativeItem flex-box">
                  <img
                    class="u_imgF imgBlock noevents-img"
                    :src="rankList[0].avatar"
                    onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                  />
                  <img
                    class="tou_imgF absoluteItem centerX imgBlock noevents-img"
                    src="../../assets/pk4/touimg1.png"
                  />
                  <div
                    class="allA"
                    :data-uid="rankList[0].userid"
                    @click="linkto"
                    v-show="se_type_an != 2"
                  ></div>
                </div>
                <div class="name_box apostrophe">
                  {{ rankList[0].nickname }}
                </div>
                <div class="pk_kg" v-show="se_type_an == 0">
                  <img
                    class="imgBlock noevents-img"
                    :src="rankList[0].season_level_img"
                  />
                </div>
                <div class="jifen_c" v-show="se_type_an == 0">
                  积分：{{ rankList[0].integral }}
                </div>
                <div class="jifen_c" v-show="se_type_an == 1">
                  {{ rankList[0].winnernum }} 胜场
                </div>
                <div class="jifen_c" v-show="se_type_an == 2">
                  贡献：{{ rankList[0].sp }}
                </div>
                <div class="jifen_c" v-show="se_type_an == 3">
                  MVP: {{ rankList[0].mvp_num }} 次
                </div>
              </div>
              <div :class="['th_con', 'flex-box', { marTop: se_type_an != 0 }]">
                <div class="first_con flex-box">
                  <img
                    class="m1_img imgBlock noevents-img"
                    src="../../assets/pk4/m2.png"
                  />
                  <div class="kg_con kg_conL relativeItem flex-box">
                    <img
                      class="u_img imgBlock noevents-img absoluteItem centerX"
                      :src="rankList[1].avatar"
                      onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                    />
                    <img
                      class="tou_img imgBlock noevents-img"
                      src="../../assets/pk4/touimg2.png"
                    />
                    <div
                      class="allA"
                      :data-uid="rankList[1].userid"
                      @click="linkto"
                      v-show="se_type_an != 2"
                    ></div>
                  </div>
                  <div class="name_box apostrophe">
                    {{ rankList[1].nickname }}
                  </div>
                  <div class="pk_kg pk_ran2" v-show="se_type_an == 0">
                    <img
                      class="imgBlock noevents-img"
                      :src="rankList[1].season_level_img"
                    />
                  </div>
                  <div class="jifen_c" v-show="se_type_an == 0">
                    积分：{{ rankList[1].integral }}
                  </div>
                  <div class="jifen_c" v-show="se_type_an == 1">
                    {{ rankList[1].winnernum }} 胜场
                  </div>
                  <div class="jifen_c" v-show="se_type_an == 2">
                    贡献：{{ rankList[1].sp }}
                  </div>
                  <div class="jifen_c" v-show="se_type_an == 3">
                    MVP: {{ rankList[1].mvp_num }} 次
                  </div>
                </div>
                <div class="first_con flex-box">
                  <img
                    class="m1_img imgBlock noevents-img"
                    src="../../assets/pk4/m3.png"
                  />
                  <div class="kg_con kg_conR relativeItem flex-box">
                    <img
                      class="u_img imgBlock noevents-img absoluteItem centerX"
                      :src="rankList[2].avatar"
                      onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                    />
                    <img
                      class="tou_img imgBlock noevents-img"
                      src="../../assets/pk4/touimg3.png"
                    />
                    <div
                      class="allA"
                      :data-uid="rankList[2].userid"
                      @click="linkto"
                      v-show="se_type_an != 2"
                    ></div>
                  </div>
                  <div class="name_box apostrophe">
                    {{ rankList[2].nickname }}
                  </div>
                  <div class="pk_kg pk_ran2" v-show="se_type_an == 0">
                    <img
                      class="imgBlock noevents-img"
                      :src="rankList[2].season_level_img"
                    />
                  </div>
                  <div class="jifen_c" v-show="se_type_an == 0">
                    积分：{{ rankList[2].integral }}
                  </div>
                  <div class="jifen_c" v-show="se_type_an == 1">
                    {{ rankList[2].winnernum }} 胜场
                  </div>
                  <div class="jifen_c" v-show="se_type_an == 2">
                    贡献：{{ rankList[2].sp }}
                  </div>
                  <div class="jifen_c" v-show="se_type_an == 3">
                    MVP: {{ rankList[2].mvp_num }} 次
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 四名一下的排名 -->
        <div class="four_box relativeItem">
          <img class="imgBlock noevents-img" src="../../assets/pk4/bgt02.png" />
          <div class="absoluteItem si_con centerX">
            <div class="head_tit relativeItem">
              <img
                class="imgBlock noevents-img"
                src="../../assets/pk4/titbg.png"
              />
              <div class="pf_tit flex-box absoluteItem">
                <div class="p_lft flex-box">
                  <div class="te_text">排名</div>
                  <div class="te_text">主播&昵称</div>
                </div>
                <div class="te_text">
                  {{ topTit }} <i v-show="se_type_an == 2">&nbsp;&nbsp;</i>
                </div>
              </div>
            </div>
            <ul id="ulboxs" class="ul_box relativeItem">
              <li
                class="lis flex-box"
                v-for="(n, i) in rankList"
                :key="i"
                v-show="i > 2"
              >
                <div class="flex-box lft_con">
                  <p class="pai_box">{{ i + 1 }}</p>
                  <div class="u_info flex-box">
                    <div class="avatar_div relativeItem">
                      <img
                        class="imgBlock noevents-img"
                        :src="n.avatar"
                        onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                      />
                      <div
                        class="allA"
                        :data-uid="n.userid"
                        @click="linkto"
                        v-show="se_type_an != 2"
                      ></div>
                    </div>
                    <div class="name_div flex-box">
                      <p class="uname_p apostrophe">
                        {{ n.nickname }}
                      </p>
                      <img
                        v-show="se_type_an == 0"
                        class="imgBlock noevents-img"
                        :src="n.season_level_img"
                      />
                    </div>
                  </div>
                </div>
                <div class="rgt_con" v-show="se_type_an == 0">
                  {{ n.integral }}
                </div>
                <div class="rgt_con" v-show="se_type_an == 1">
                  {{ n.winnernum }}胜场
                </div>
                <div class="rgt_con" v-show="se_type_an == 2">{{ n.sp }}</div>
                <div class="rgt_con" v-show="se_type_an == 3">
                  {{ n.mvp_num }}次
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 自己的盒子 -->
        <div
          class="me_box relativeItem"
          v-show="isAchor > 0 || se_type_an == 2"
        >
          <img class="imgBlock noevents-img" src="../../assets/pk4/mebg.png" />
          <div class="absoluteItem me_main flex-box">
            <div class="me_pai">
              <p v-if="meInfo.rank > 0">{{ meInfo.rank }}</p>
              <p v-else class="wei">未上榜</p>
            </div>
            <div class="me_ctr flex-box">
              <div class="me_avt">
                <img
                  class="imgBlock noevents-img"
                  :src="meInfo.avatar"
                  onerror="this.src='http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                />
              </div>
              <div class="me_info flex-box">
                <p class="apostrophe">{{ meInfo.nickname }}</p>
                <img
                  v-show="se_type_an == 0"
                  class="imgBlock noevents-img"
                  :src="meInfo.season_level_img"
                />
              </div>
            </div>
            <div class="rgt_con" v-show="se_type_an == 0">
              {{ meInfo.integral }}
            </div>
            <div class="rgt_con" v-show="se_type_an == 1">
              {{ meInfo.winnernum }}胜场
            </div>
            <div class="rgt_con" v-show="se_type_an == 2">{{ meInfo.sp }}</div>
            <div class="rgt_con" v-show="se_type_an == 3">
              {{ meInfo.mvp_num }}次
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--规则-->
    <div class="gz_main relativeItem" v-show="show_gz">
      <div class="bgline"></div>
      <div class="rolue_box relativeItem">
        <img src="../../assets/pk4/rimg01.png" class="imgBlock noevents-img" />
        <img src="../../assets/pk4/rimg1.png" class="imgBlock noevents-img" />
        <img src="../../assets/pk4/rimg2.png" class="imgBlock noevents-img" />
        <img src="../../assets/pk4/rimg3.png" class="imgBlock noevents-img" />
        <img src="../../assets/pk4/rimg4.png" class="imgBlock noevents-img" />
        <img src="../../assets/pk4/rimg5.png" class="imgBlock noevents-img" />
        <img src="../../assets/pk4/rimg6.png" class="imgBlock noevents-img" />
        <div class="ditext">
          <img
            src="../../assets/pk4/ditext.png"
            class="imgBlock noevents-img"
          />
        </div>
      </div>
      <div class="bot_text">本活动的最终解释权归朱贝官方平台所有</div>
    </div>

    <!-- 活动未开始和结束的弹窗 -->
    <div class="tc" @touchmove.prevent v-show="show_tc">
      <div class="main error_tip absoluteItem centerImg" @click.stop>
        <img
          class="imgBlock noevents-img"
          src="../../assets/pk4/tcimg.png"
          alt=""
        />
        <!--关闭按钮-->
        <a class="close-tc imgBlock absoluteItem" @click="show_tc = false">
          <img src="../../assets/pk4/close.png" class="imgBlock noevents-img" />
        </a>
        <div class="error-tip absoluteItem centerImg" v-if="this.is_start == 0">
          <p>本赛季将于1月15日正式开启</p>
          <p>更多精彩，敬请期待！</p>
        </div>
        <div class="error-tip absoluteItem centerImg" v-else>
          <p>非常抱歉</p>
          <p>S4赛季排位赛活动已结束！</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lottie from "lottie-web";

export default {
  name: "pk-list",
  data() {
    return {
      anim_obj: null, //lottie动画对象
      anim_obj2: null, //lottie动画对象第二段
      show_gif: false, //是否显示gif动画
      show_error_tip: false, //是否展示错误信息的标识
      gz_ac: 0, //0主播奖励 1用户奖励
      show_tc: false, //显示活动开始和结束的弹窗
      show_gz: false, //是否显示规则
      se_type_an: 0, //按钮切换标识 0：冲分 1：胜利 2：贡献 3：mvp
      is_start: 0, //判断活动是否开始 0未开始 1开始 2结束
      rankList: [], //排名的数组
      topTit: "赛季积分",
      startTime: 0, //开始时间
      endTime: 0, //结束时间
      page: 1,
      isCordBlank: false,
      touid: null, //被查看人的uid
      isAchor: 0, //0用户  大于0主播
      meInfo: {}, //自己的信息
    };
  },
  methods: {
    // 点击规则
    clickRolue(flag) {
      if (this.is_start == 0) {
        this.show_tc = true;
      } else {
        this.show_gz = flag;
      }
    },

    /**获取mvp榜单数据 */
    get_rankList(apiname) {
      let _this = this,
        data = {
          page: 1,
          pagesize: 50,
        };
      if (_this.touid != null) {
        data.touserid = _this.touid;
      }

      this.$jsonp(this.$apis(apiname), data, (res) => {
        if (apiname == "pk4_seasonList") {
          _this.startTime = res.data.data.result.list.season.starttime;
          _this.endTime = res.data.data.result.list.season.endtime;
          _this.isAchor = res.data.data.result.list.levelInfo.isachor;
          _this.judgeTime();
        }
        _this.meInfo = res.data.data.result.list.levelInfo;
        let ls = res.data.data.result.list.list;
        if (ls.length > 0) {
          // 有数据
          _this.rankList = ls;
        } else {
          _this.isCordBlank = true;
        }
        _this.get_page_width();
      });
    },

    // 判断活动是否开启
    judgeTime() {
      let _this = this;
      let nowTime = _this.$tool.getTimeC();
      // 开始时间  结束时间
      if (nowTime < _this.startTime) {
        this.show_gz = true;
        this.is_start = 0;
      } else if (nowTime >= _this.startTime && nowTime <= _this.endTime) {
        this.show_gz = false;
        this.is_start = 1;
      } else {
        this.show_tc = true; //显示活动结束
        this.is_start = 2;
      }
      setTimeout(() => {
        this.getBoxHeight();
      }, 400);
    },

    // 获取four_box的高度
    getBoxHeight() {
      let fourBox = document.querySelector(".four_box"),
        ulBox = document.querySelector(".ul_box");
      ulBox.style.height = fourBox.offsetHeight - 60 + "px";
    },

    /**关闭webview */
    close_web() {
      this.$appAc.closeWeb();
    },

    // 判断屏幕大小
    get_page_width() {
      setTimeout(() => {
        if (document.body.clientWidth > 375) {
          let lis = document.querySelectorAll(".lis"),
            ul_box = document.querySelector(".ul_box");
          for (let i = 0; i < lis.length; i++) {
            lis[i].classList.add("lisAdd");
          }
          ul_box.classList.add("ulAdd");
          if (document.querySelector(".kg_first")) {
            document.querySelector(".kg_first").style.height = "125px";
          }
          if (document.querySelector(".kg_con")) {
            document.querySelector(".kg_conL").style.height = "90px";
            document.querySelector(".kg_conR").style.height = "90px";
          }
        }
      }, 300);
    },

    /**点击跳转 */
    linkto(e) {
      this.$tool.to_person_page(e);
    },

    /**加载更多 暂时没用 */
    scrollGetMore(apiname) {
      let item = document.querySelector("#ulboxs");
      let _this = this;
      let utop,
        sHeight,
        cheight = null;
      item.addEventListener("scroll", (e) => {
        (utop = e.target.scrollTop),
          (sHeight = e.target.scrollHeight),
          (cheight = e.target.clientHeight);
        if (sHeight - (utop + cheight) <= 50 && _this.list_more) {
          _this.page++;
          _this.get_rankList(apiname);
        }
      });
    },

    /**动画初始化 */
    init_anim() {
      let _this = this;
      //标题动画
      this.anim_obj = lottie.loadAnimation({
        container: document.getElementById("anim"),
        renderer: "svg", // 渲染方式:svg、canvas
        loop: false, //循环播放，默认：false
        autoplay: true, //自动播放 ，默认true
        path: "/S4/data.json",
      });
      this.anim_obj2 = lottie.loadAnimation({
        container: document.getElementById("anim2"),
        renderer: "svg", // 渲染方式:svg、canvas
        loop: true, //循环播放，默认：false
        autoplay: false, //自动播放 ，默认true
        path: "/S42/data.json",
      });

      this.anim_obj.addEventListener("complete", () => {
        _this.show_gif = true;
        _this.anim_obj2.play();
      });
    },
  },
  mounted: function () {
    if (this.$tool.isStr(this.$route.query.uid)) {
      this.touid = this.$route.query.uid;
    }
    this.$tool.setTitle("PK排行榜");
    this.init_anim(); //顶部动画
    this.get_rankList("pk4_seasonList"); // 冲分榜单
  },
  watch: {
    se_type_an() {
      this.rankList = [];
      if (this.se_type_an == 0) {
        this.topTit = "赛季积分";
        this.get_rankList("pk4_seasonList");
      } else if (this.se_type_an == 1) {
        this.topTit = "赛季胜场";
        this.get_rankList("pk4_winnerList");
      } else if (this.se_type_an == 2) {
        this.topTit = "贡献值";
        this.get_rankList("pk4_pointList");
      } else if (this.se_type_an == 3) {
        this.topTit = "MVP次数";
        this.get_rankList("pk4_mvpList");
      }
    },
  },
};
</script>

<style scoped>
#pk-list {
  width: 100%;
  min-height: 100vh;
  /* background: linear-gradient(to right, #1110b5, #66123f); */
  overflow-x: hidden;
}
.close_img {
  position: fixed;
  width: 10%;
  top: 60px;
  z-index: 10;
}

/* 顶部动画的盒子 */
.head_box {
  width: 100%;
  /* height: 405px;  后边删除的高度 */
  background-color: #210000;
}
.two_gif {
  top: 0;
}
#anim,
#anim2 {
  top: 0;
  width: 100%;
  z-index: 1;
}

/**榜单 */
.gz-btn {
  position: fixed;
  width: 20%;
  right: 0;
  top: 272px;
  z-index: 9;
}

/* 榜单主体 */
.list_div {
  width: 100%;
  background-color: #210000;
  min-height: 100vh;
  margin-top: -25px;
  z-index: 5;
}
.list_div .bgline {
  margin-top: -28px;
}
/* 按钮切换 */
.type-an2 {
  width: 100%;
  justify-content: space-around;
  align-items: flex-end;
  padding: 0 6px;
  z-index: 8;
}
.type-an2 .side_con {
  width: 31%;
  height: 38px;
}
.side_con img {
  width: 100%;
}
.type-an2 .side_con:nth-child(3) {
  margin: 0 2px 0 4px;
}
.type-an2 .side_con:nth-child(4) {
  margin: 0 4px 0 2px;
}
.type-an2 .side_con:nth-child(5) {
  z-index: 2;
}
.chi_img {
  width: 9%;
}
.side1 {
  margin-left: -6px;
}
.side4 {
  margin-right: -5px;
}
/* 按钮切换样式完 */

/* 榜单中间开始样式 */
.rank_main {
  margin-top: -6rem;
  padding-bottom: 2.8rem; /* 自己的盒子固定定位时需要的 */
}
.san_con {
  width: 100%;
  top: 7%;
}
.si_con {
  width: 100%;
  top: 1%;
}
.first_con {
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.first_con .m1_img {
  width: 36%;
  margin: auto;
}
.kg_con {
  width: 66%;
  height: 86px;
  /* padding-top: 7%; */
  justify-content: center;
  margin-top: 6px;
}
.kg_first {
  width: 66%;
  height: 115px;
  padding-top: 8%;
  justify-content: center;
}
.kg_con .u_img {
  top: 13%;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  z-index: -1;
}
.kg_first .u_imgF {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
}
.kg_first .tou_imgF {
  top: -39%;
  width: 89%;
}

.kg_con .tou_img {
  top: 0;
  width: 55%;
}

.name_box {
  width: 30%;
  text-align: center;
  margin-top: 6px;
  font-size: 0.875rem;
  color: #fff6e4;
}
.jifen_c {
  font-size: 0.75rem;
  color: #fff6e4;
}
.pk_kg {
  margin: -1px 0;
}
.pk_kg img {
  width: 30%;
  margin: auto;
}
.pk_ran2 img {
  width: 60%;
}
.th_con {
  width: 100%;
  margin-top: 3%;
  padding: 0 5%;
}
.san_main {
  min-height: 425px;
}
.three_box {
  min-height: 425px;
}
.three_box .san_con .marTop {
  margin-top: 16%;
}
.th_con .first_con {
  width: 50%;
}
.th_con .first_con .m1_img {
  width: 80%;
}
.th_con .kg_con {
  width: 116%;
}
.th_con .name_box {
  width: 55%;
}

.si_con .head_tit {
  padding: 0 8%;
}
i {
  font-style: normal;
}
.head_tit .pf_tit {
  left: 11%;
  top: 50%;
  transform: translateY(-50%);
  width: 78%;
  justify-content: space-between;
  font-size: 13px;
  font-weight: bold;
}
.p_lft {
  width: 50%;
  justify-content: space-between;
}
.te_text {
  color: #f9ecc2;
  background-image: -webkit-linear-gradient(top, #f9ecc2, #f1dd8f);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
/* 四名一下的样式 */
.ul_box {
  padding: 8px 8%;
  margin-top: 6px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.ul_box .lis {
  width: 100%;
  align-items: center;
  margin-bottom: 15px;
}
.si_con .ul_box .lisAdd {
  margin-bottom: 20px;
}
.si_con .ulAdd {
  padding-top: 16px;
}

.lis .avatar_div {
  width: 40px;
  height: 40px;
  padding: 1px;
  margin-right: 15px;
  background-color: #fff6e4;
  border-radius: 50%;
}
.avatar_div img {
  border-radius: 50%;
  width: 38px;
  height: 38px;
}
.lis .lft_con {
  width: 60%;
  align-items: center;
}
.lft_con .pai_box {
  font-size: 0.9375rem;
  width: 30%;
  color: #fff6e4;
  text-align: center;
}
.lft_con .u_info {
  width: 80%;
  margin-left: 18px;
  align-items: center;
}
.lis .name_div {
  width: 100%;
  flex-direction: column;
  justify-content: center;
}
.name_div .uname_p {
  width: 80px;
  font-size: 0.8125rem;
  color: #fff6e4;
  padding-left: 2px;
}
.name_div img {
  margin-top: 3px;
  width: 80px;
}
.lis .rgt_con {
  margin-left: 20%;
  font-size: 14px;
  color: #fff6e4;
  display: flex;
  align-items: center;
}

/* ---------------------------------------- */
/* 自己的盒子 */
.me_box {
  position: fixed;
  left: 0;
  bottom: 0;
}
.me_main {
  top: 56%;
  transform: translateY(-50%);
  padding: 0 7%;
  align-items: center;
  width: 100%;
}
.me_pai {
  width: 80px;
  font-size: 0.9375rem;
  color: #fff6e4;
  text-align: center;
}
.me_pai .wei {
  font-size: 0.75rem;
}
.me_ctr {
  width: 66%;
  align-items: center;
  margin-left: 8px;
}
.me_avt {
  width: 50px;
  height: 50px;
  padding: 1px;
  margin-right: 15px;
  background-color: #fff6e4;
  border-radius: 50%;
}
.me_avt img {
  border-radius: 50%;
  width: 48px;
  height: 48px;
}

.me_info {
  width: 66%;
  flex-direction: column;
  justify-content: center;
  color: #fff6e4;
}
.me_info p {
  width: 100%;
  font-size: 0.875rem;
}
.me_info img {
  margin-top: 3px;
  width: 80px;
}
.me_box .rgt_con {
  width: 36%;
  color: #fff6e4;
  font-size: 14px;
  margin-left: 53px;
}
.martopfu {
  margin-top: -2px;
}
/* 规则 */
.gz_main {
  width: 100%;
  background-color: #270000;
  margin-top: -35px;
}
.bgline {
  width: 100%;
  height: 130px;
  background: url("../../assets/pk4/bgline.png") no-repeat;
  background-size: 100% 100%;
}
.rolue_box {
  margin-top: -110px;
}
.ditext {
  padding: 20px 6%;
}
.bot_text {
  width: 100%;
  text-align: center;
  color: #780800;
  font-size: 11px;
  padding: 30px 0 60px;
}

/**弹窗  */
.tc .main {
  width: 85%;
  transform-origin: left top;
  animation: adAnimation 0.3s forwards;
}
.tc .main .error-tip {
  width: 100%;
  font-size: 0.875rem;
  color: #fff6e4;
  text-align: center;
}
.tc .close-tc {
  width: 31px;
  height: 31px;
  top: 5px;
  right: 0;
}
.allA {
  z-index: 5;
}
.nomore {
  color: #fff;
  font-size: 12px;
  width: 100%;
  text-align: center;
  margin-top: 12px;
}

.allA {
  z-index: 5;
}
</style>
